import { EffectCallback, useEffect } from "react";

export function useOnce(fn: EffectCallback) {
  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(fn, []);
}
